//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

export interface ApiConfig {
  MC_API_URL: string;
}

// The API base URL.  Defaults to the relative `/api/` used behind the Docker
// nginx proxy.  Override with the VITE_MC_API_URL env var: set it in a
// gitignored `.env.local` for local development, or in the environment (CI
// points it at a directly-run backend).
const rawApiUrl = import.meta.env.VITE_MC_API_URL ?? '/api/';

export const config: ApiConfig = {
  // Normalize to a trailing slash so callers that concatenate an endpoint
  // path directly (e.g. the download anchor in DownloadFrame) can't produce
  // "/apidownloadframe" when VITE_MC_API_URL is set without one.
  MC_API_URL: rawApiUrl.endsWith('/') ? rawApiUrl : `${rawApiUrl}/`
};
